import React, { Component } from "react"
import { Menu, Segment, Icon } from "semantic-ui-react"
import "./MenuEdition.css"

export default class MenuEdition extends Component {
  constructor(props) {
    super(props)
  }
  state = { activeItem: "En-têtes" }

  handleItemClick = (e, { name }) => this.setState({ activeItem: name })

  render() {
    const { activeItem } = this.state

    return (
      <Menu.Item
        id={this.props.id}
        name={this.props.name}
        active={activeItem === this.props.name}
        onClick={this.handleItemClick}
      >
        <Icon id={this.props.id} name={this.props.nameIcon} />
        {this.props.name}
      </Menu.Item>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Pro/DevisFactures/EditionDevisFactures/MenuEdition.js